import { FC } from 'react';
import { TableListQueryResponse } from '../../../_core/interfaces/table-list-query.interface';
import { OneRosterFamilyDto } from '@families-link/shared';
import { useTranslation } from 'react-i18next';
import { useReactTable, getCoreRowModel, getFilteredRowModel } from '@tanstack/react-table';
import { CoreTable, CoreTableEmptyBody } from '../../../_core/components/_ui/core-table';
import { useOneRosterFamiliesTableColumns } from '../../hooks/table-columns/oneroster-families-table-columns.hook';

export interface OneRosterFamiliesTableHandlers {
	onView(family: OneRosterFamilyDto): void;
}

type OneRosterFamiliesTableProps = TableListQueryResponse<OneRosterFamilyDto> & OneRosterFamiliesTableHandlers;

export const OneRosterFamiliesTable: FC<OneRosterFamiliesTableProps> = (props) => {
	const {
		data,
		sorting,
		onSortingChange,
		loading,
		hasMore,
		fetchMore,
		scrollRef,
		onView,
		rowSelection,
		onRowSelectionChange,
	} = props;

	const [t] = useTranslation();

	const columns = useOneRosterFamiliesTableColumns({
		onView,
	});

	const table = useReactTable<OneRosterFamilyDto>({
		data,
		columns,
		state: {
			sorting,
			rowSelection,
		},
		onSortingChange,
		getCoreRowModel: getCoreRowModel(),
		getFilteredRowModel: getFilteredRowModel(),

		enableRowSelection: true,
		onRowSelectionChange,
		getRowId: (row) => row.studentId,
	});

	return (
		<CoreTable
			px={0}
			ref={scrollRef}
			loading={loading}
			hasMore={hasMore}
			threshold={200}
			emptyListComponent={
				<CoreTableEmptyBody label={t('profile.sessions.table.empty-title')} description={t('families.no-families')} />
			}
			fetchMore={fetchMore}
			rowModel={table.getRowModel()}
			headerGroups={table.getHeaderGroups()}
		/>
	);
};
